import { render, staticRenderFns } from "./LabelAzGroup.vue?vue&type=template&id=536fb6f6"
import script from "./LabelAzGroup.vue?vue&type=script&lang=js"
export * from "./LabelAzGroup.vue?vue&type=script&lang=js"
import style0 from "./LabelAzGroup.vue?vue&type=style&index=0&id=536fb6f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports